import { create } from 'zustand';
import type { AuthUser, AuthStatus } from '@/features/auth/types';

interface AuthState {
  user: AuthUser | null;
  status: AuthStatus;
  setUser: (user: AuthUser | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'loading',
  setUser: (user) =>
    set({ user, status: user ? 'authenticated' : 'unauthenticated' }),
}));
